export default "__VITE_ASSET__VoKZsEK5__"